import React from "react";
import { LocaleContext } from "./index.jsx";
import { translate, getLangCode } from "./translate";

class Locale extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: getLangCode()
    };
    this.handle = this.handle.bind(this);
  }

  // La búsqueda vive en translate.js, para que también la alcance el código que
  // está fuera del árbol de React. Aquí sólo se fija el idioma del contexto.
  handle(s) {
    return translate(s, this.state.current);
  }

  render() {
    return (
      <LocaleContext.Provider
        value={{
          current: this.state.current,
          handle: this.handle
        }}
      >
        {this.props.children}
      </LocaleContext.Provider>
    );
  }
}

export { Locale };
